import { render, staticRenderFns } from "./ib-picker-file.vue?vue&type=template&id=2912d272&lang=pug&"
import script from "./ib-picker-file.vue?vue&type=script&lang=js&"
export * from "./ib-picker-file.vue?vue&type=script&lang=js&"
import style0 from "./ib-picker-file.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2912d272')) {
      api.createRecord('2912d272', component.options)
    } else {
      api.reload('2912d272', component.options)
    }
    module.hot.accept("./ib-picker-file.vue?vue&type=template&id=2912d272&lang=pug&", function () {
      api.rerender('2912d272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ib-picker-file.vue"
export default component.exports